import { render, staticRenderFns } from "./NotesTextField.vue?vue&type=template&id=38eee1d1"
import script from "./NotesTextField.vue?vue&type=script&lang=js"
export * from "./NotesTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports